<template>
  <div>
    <h2 class="createTitle">创建应用</h2>

    <div class="createHtml-box">
      <div class="createHtml">
        <div class="createBody">
          <div class="steps-box">
            <el-steps :active="activeStep - 1" align-center>
              <el-step title="选择功能板块" description="选择想要您想要创建的功能，选择多个可享打包价噢"></el-step>
              <el-step title="选择套餐与功能" description="查看套餐内功能"></el-step>
              <el-step title="确认订单" description="确认您选购的套餐和功能清单，并选择支付方式完成支付"></el-step>
              <el-step title="创建应用" description="立即填写应用的名字吧！给你的软件起个响亮的名字，可稍后设置"></el-step>
            </el-steps>
          </div>
        </div>
      </div>

      <!-- 各个视图 -->
      <div>
        <Step1View v-if="activeStep === 1" :planData="planData" @handle-next="handleNextStep" @handle-prev="handlePreviousStep"></Step1View>
        <Step2View v-if="activeStep === 2" :planData="planData" @handle-next="handleNextStep" @handle-prev="handlePreviousStep"></Step2View>
        <Step3View v-if="activeStep === 3" :planData="planData" @handle-next="handleNextStep" @handle-prev="handlePreviousStep" @handle-uuid="val => uuid = val"></Step3View>
        <Step4View v-if="activeStep === 4" :uuid="uuid" @handle-next="handleNextStep" @handle-prev="handlePreviousStep"></Step4View>
      </div>
    </div>

  </div>
</template>

<script>
import Step1View from './components/step1'
import Step2View from './components/step2'
import Step3View from './components/step3'
import Step4View from './components/step4'
import { fetchSupplyChainPlanList } from '@/api/supply-chain/supply-chain'

export default {
  components: {
    Step1View, Step2View, Step3View, Step4View
  },
  data() {
    return {
      // 当前的步骤
      activeStep: 1,
      uuid: '',
      planData: []
    }
  },
  activated() {
    this.activeStep = 1
    // 初始化数据
    this._fetchData()
  },
  methods: {
    // 上一步
    handlePreviousStep() {
      if (this.activeStep <= 1) {
        this.activeStep = 1
      } else {
        this.activeStep--
      }
    },
    // 下一步
    handleNextStep() {
      if (this.activeStep >= 4) {
        this.activeStep = 4
      } else {
        this.activeStep++
      }
    },
    _fetchData() {
      const loading = this.$loading({ lock: true, text: "Loading", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)" });
      fetchSupplyChainPlanList().then(res => {
        res.data.forEach((element, index) => {
          element.laber = false;
          if (index === 0) {
            element.spanActive = true;
          } else {
            element.spanActive = false;
          }
          element.laber = false;
          loading.close();
        });
        this.planData = res.data;
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.createTitle {
  margin: 41px 0 15px;
  color: #2d3748;
  font-size: 18px;
  display: block;
}

.createHtml-box {
  overflow: hidden;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
}

.createHtml {
  border-bottom: 1px solid #f5f5f5;
}

.createBody {
  width: 100%;
  background: #ffffff;
  border-radius: 22px;
}

.steps-box {
  padding: 40px 100px;
}

.createrAn-Buttom-box {
  widows: 100%;
  display: flex;
  width: 77.6%;
  padding: 40px 0 80px;
  margin: 0 auto;
  justify-content: space-between;
}

.createrAn-Buttom {
  .span0 {
    display: inline-block;
    width: 96px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }
  .span9 {
    display: inline-block;
    width: 208px;
    height: 37px;
    line-height: 37px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 12px;
    cursor: pointer;
  }

  .span1 {
    color: #788598;
    background: #edf1f6;
  }
  .span1:active {
    background: #f8f8f8;
  }

  .span2 {
    color: rgb(235, 233, 233);
    background: #1890ff;
    margin-left: 20px;
  }
  .span2:active {
    background: #2d97fa;
  }
}

.loading8Clss {
  background: #e2f0ff !important;
  cursor: no-drop !important;
  color: #ffffff !important;
}

.button {
  width: 236px;
  height: 37px;
  background: #1890ff;
  border-radius: 12px;
  text-align: center;
  display: inline-block;
  font-size: 14px;
  color: #fff;
}

.button:active {
  background: #399fff;
}

@media screen and (max-width: 600px) {
  .createHtml {
    display: none !important;
  }

  .createrAn-Buttom {
    display: flex !important;
    padding: 20px !important;
    justify-content: center;
    align-items: center;
    .span2 {
      margin-left: 20px !important;
    }
  }
}
</style>
